import {
  faGear,
  faHeader,
  faImage,
  faLayerGroup,
  faLink,
  faQuoteLeft,
  faShare,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, message, Modal, Popover, Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLoaderState,
  getUserDetailsFromReducer,
  updateLoader,
  updateUserDetailsInReducer,
} from "Store/reducers/Auth/AuthSlice";
import { API } from "aws-amplify";
import useCustomBreakpoints from "Hooks/UseCustomBreakPoints";
import { primaryColor } from "ThemeCustom";
import Lottie from "react-lottie";
import animationData from "Assets/LottieAnimations/lottie-animations.json";
import { ActionBarSetting } from "./ActionBarSetting";
import ShareLinks from "./ShareLinks";
import { AddSocialMedia } from "./AddSocialMedia";

export const ActionBar = ({ onAddCard }) => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const isLoading = useSelector(getLoaderState);
  const [addSocialMediaModel, setAddSocialMediaModel] = useState(false);
  const [showLottie, setshowLottie] = useState(false);
  const [addShareModel, setAddShareModel] = useState(false);

  const buttons = [
    {
      icon: faLink,
      text: "Add Links ",
      onClick: () => setAddSocialMediaModel(!addSocialMediaModel),
    },
    {
      icon: faHeader,
      text: "Add Title",
      onClick: () => onAddCard("title"),
    },
    {
      icon: faQuoteLeft,
      text: "Add Text",
      onClick: () => onAddCard("discription"),
    },
    {
      icon: faImage,
      text: "Add Image",
      onClick: () => onAddCard("image"),
    },
    {
      icon: faLayerGroup,
      text: "Add Card",
      onClick: () => onAddCard("card"),
    },
  ];

  const url = `https://inprofile.co/${userDetails?.username}`;
  const dispatch = useDispatch();

  const handlePublish = async () => {
    try {
      setshowLottie(true);
      if (!userDetails?.isDraft) {
        handleGoToURL();
        return;
      }
      dispatch(updateLoader(true));
      await API.get("REST", "/publish");
      message.success("Your Profile is published!");
      dispatch(updateUserDetailsInReducer({ ...userDetails, isDraft: false }));
      // setAddShareModel(prev => !prev);
      return true;
    } catch (error) {
      message.error("Unable to publish your profile at this moment!!!");
      return false;
    } finally {
      dispatch(updateLoader(false));
      setshowLottie(false);
    }
  };

  const handleGoToURL = () => {
    window.open(url);
  };

  const screen = useCustomBreakpoints();
  const smallScreen = screen.xs || screen.sm;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div>
      {showLottie && (
        <div className="lottie-animation fixed z-10 inset-0 flex justify-center items-center ">
          <div className="w-full md:w-1/2 h-full">
            <Lottie options={defaultOptions} height={"100%"} width={"100%"} />
          </div>
        </div>
      )}

      <div className="border-gray-100 border-2 flex items-center space-x-2 px-2 py-2 bg-white opacity-95 shadow-2xl rounded-lg fixed bottom-5 z-50 left-1/2 translate-x-[-50%]">
        {userDetails?.isDraft ? (
          <div className="h-2 w-2 rounded-full bg-primary animate-pulse"></div>
        ) : null}

        <Button
          onClick={
            userDetails?.isDraft
              ? handlePublish
              : () => setAddShareModel(!addShareModel)
          }
          type={"primary"}
          className=" px-2 py-1  focus:outline-none w-auto whitespace-nowrap"
          loading={isLoading}
        >
          {smallScreen
            ? !isLoading && (
                <FontAwesomeIcon
                  icon={userDetails?.isDraft ? faUpload : faShare}
                />
              )
            : !userDetails?.isDraft
            ? "Share Profile"
            : isLoading
            ? "Saving.."
            : "Publish Profile"}
        </Button>

        <div className="w-[2px] h-4 rounded-lg bg-gray-200"></div>

        {buttons.map((item, index) => (
          <div key={index}>
            <Tooltip
              title={item?.text}
              color={primaryColor}
              overlayInnerStyle={{ fontSize: "0.75rem" }}
            >
              <button
                className="p-1 px-2 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none text-gray-500"
                onClick={item?.onClick}
              >
                <FontAwesomeIcon icon={item?.icon} />
              </button>
            </Tooltip>
          </div>
        ))}

        <div className="w-[2px] h-4 rounded-lg bg-gray-200"></div>

        <button className="p-1 px-2 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none text-gray-500">
          <Popover
            content={<ActionBarSetting />}
            title={"Settings"}
            trigger="click"
          >
            <FontAwesomeIcon icon={faGear} />
          </Popover>
        </button>

        <Modal
          title="Share Inprofile"
          open={addShareModel}
          footer={null}
          onCancel={() => setAddShareModel(false)}
          centered
        >
          <ShareLinks />
        </Modal>
        <AddSocialMedia
          addSocialMediaModel={addSocialMediaModel}
          setAddSocialMediaModel={setAddSocialMediaModel}
        />
      </div>
    </div>
  );
};
